import { RtUIOptions } from './options';
import { PDF_VIEWER_CONFIG_TOKEN } from './pdf-viewer/pdf-viewer.di';
import { PdfViewerConfig } from './pdf-viewer/pdf-viewer.types';

export const UIRootProviders = (options?: RtUIOptions, pdfViewerConfig?: PdfViewerConfig) => [
  {
    provide: RtUIOptions,
    useValue: options,
  },
  {
    provide: PDF_VIEWER_CONFIG_TOKEN,
    useValue: pdfViewerConfig,
  },
];
